/* NOMO: "Van keychain naar tote" scene + heading/image reveals for the nomo-unfold, nomo-steps and nomo-sizes sections.
   Desktop: pinned scroll scene, one frame at a time (no cross-fades, so no ghost images).
   Mobile / no GSAP: no pin; the four steps play by themselves while the scene is on screen, tap to replay.
   Reduced motion: the same slideshow, slower and without the unroll wipe. */
(() => {
  if (window.__nomoUnfold) return;
  window.__nomoUnfold = true;
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const start = () => {
    const unfold = document.querySelector('[data-nb-unfold]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasGsap = !!(window.gsap && window.ScrollTrigger);

    // Reduced motion: no scroll-pin and no wipe, but the steps still play as a calm slideshow.
    if (reduce) unfold?.classList.add('is-gentle');

    if (hasGsap && !reduce) {
      const { gsap, ScrollTrigger } = window;
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.config({ ignoreMobileResize: true, autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load' });

      $$('[data-nb-split]').forEach(heading => {
        if (heading.closest('[data-nb-unfold]')) return;
        const walk = node => [...node.childNodes].forEach(child => {
          if (child.nodeType === 3) {
            const fragment = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(part => {
              if (!part) return;
              if (/^\s+$/.test(part)) { fragment.appendChild(document.createTextNode(' ')); return; }
              const word = document.createElement('span');
              word.className = 'nb-w';
              word.setAttribute('aria-hidden', 'true');
              const inner = document.createElement('span');
              inner.textContent = part;
              word.appendChild(inner);
              fragment.appendChild(word);
            });
            child.replaceWith(fragment);
          } else if (child.nodeType === 1) {
            walk(child);
          }
        });
        heading.setAttribute('aria-label', heading.textContent.trim().replace(/\s+/g, ' '));
        walk(heading);
        gsap.from($$('.nb-w > span', heading), { yPercent: 110, duration: 1.1, ease: 'expo.out', stagger: .06, scrollTrigger: { trigger: heading, start: 'top 90%', once: true } });
      });

      $$('[data-nb-reveal]').forEach(el => gsap.fromTo(el,
        { clipPath: 'inset(14% 10% 14% 10% round 24px)' },
        { clipPath: 'inset(0% 0% 0% 0% round 24px)', duration: 1.4, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true } }
      ));
    }

    if (!unfold) return;
    const frames = $$('[data-uf]', unfold);
    const steps = $$('.nb-unfold__rail li', unfold);
    frames.forEach(img => { img.loading = 'eager'; });
    let current = -1;
    const show = index => {
      if (index === current) return;
      current = index;
      frames.forEach((frame, n) => frame.classList.toggle('is-on', n === index));
      steps.forEach((step, n) => { step.classList.toggle('is-on', n === index); step.classList.toggle('is-past', n < index); });
      unfold.classList.toggle('is-done', index === frames.length - 1);
    };
    show(0);

    const mobile = window.matchMedia('(max-width: 760px)').matches;
    if (mobile || !hasGsap || reduce) {
      // Autoplay: clip, band los, uitrollen, klaar. Hold the open tote, then start over.
      unfold.classList.add('is-auto');
      const hold = reduce ? [1600, 1300, 1300, 2800] : [1100, 900, 900, 2400];
      let timer = null;
      let index = 0;
      const next = () => {
        timer = window.setTimeout(() => {
          index = (index + 1) % frames.length;
          show(index);
          next();
        }, hold[index]);
      };
      const play = () => { if (timer) return; index = 0; show(0); next(); };
      const stop = () => { window.clearTimeout(timer); timer = null; };
      let inView = !('IntersectionObserver' in window);
      const sync = () => (inView && !document.hidden ? play() : stop());
      if (!inView) {
        new IntersectionObserver(entries => entries.forEach(entry => { inView = entry.isIntersecting; sync(); }), { threshold: .45 }).observe(unfold.querySelector('.nb-unfold__stage'));
      }
      unfold.querySelector('.nb-unfold__stage')?.addEventListener('click', () => { stop(); sync(); });
      document.addEventListener('visibilitychange', sync);
      sync();
      return;
    }

    // Desktop: pinned, scrubbed. The frame shown follows the scroll position in four equal steps.
    const { gsap, ScrollTrigger } = window;
    const headA = $$('.nb-unfold__h--a [data-word]', unfold);
    const headB = $$('.nb-unfold__h--b [data-word]', unfold);
    const dim = unfold.querySelector('[data-u-dim]');
    gsap.set(headB, { yPercent: 130 });
    gsap.set(dim, { opacity: 0 });
    gsap.timeline({
      defaults: { ease: 'power2.inOut' },
      scrollTrigger: {
        trigger: unfold, start: 'top top', end: '+=230%', scrub: .4, pin: unfold.querySelector('.nb-unfold__pin'), anticipatePin: 1,
        onUpdate: self => show(Math.min(frames.length - 1, Math.floor(self.progress * 4.6)))
      }
    })
      .from(headA, { yPercent: 130, stagger: .05, duration: .12, ease: 'power3.out' }, 0)
      .to(headA, { yPercent: -140, stagger: .04, duration: .1, ease: 'power2.in' }, .6)
      .to(headB, { yPercent: 0, stagger: .06, duration: .12, ease: 'power3.out' }, .66)
      .to(dim, { opacity: 1, duration: .08 }, .7)
      .to({}, { duration: .22 }, .78);

    const refresh = () => ScrollTrigger.refresh();
    window.addEventListener('load', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => { if (Math.abs(window.innerWidth - lastWidth) > 40) { lastWidth = window.innerWidth; refresh(); } });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
